import gql from 'graphql-tag';

export const deleteUserPhotoMutation = gql`
  mutation deleteUserPhoto($photoId: String!) {
    deleteUserPhoto(photoId: $photoId)
  }
`;
